// extracted by mini-css-extract-plugin
export default {"rate":"rate_plan_rate__QAIAb","flexibleContainer":"rate_plan_flexibleContainer__WOovo"};